import React from "react";

export const TransactionPage = () => {
  return (
    <div>Transaction Page</div>
  )
}
